export function Meta({
  label,
  value,
  mono = false
}: {
  label: string;
  value: string;
  mono?: boolean;
}): JSX.Element {
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'baseline',
        gap: 5,
        padding: '2px 8px',
        borderRadius: 5,
        background: 'var(--surface-sunken)',
        whiteSpace: 'nowrap',
        maxWidth: '100%'
      }}
    >
      <span
        style={{
          color: 'var(--text-muted)',
          fontSize: 10.5,
          textTransform: 'uppercase',
          letterSpacing: 0.3
        }}
      >
        {label}
      </span>
      <span
        className={mono ? 'mono' : undefined}
        style={{
          color: 'var(--text)',
          fontSize: mono ? 11 : 11.5,
          overflow: 'hidden',
          textOverflow: 'ellipsis'
        }}
      >
        {value}
      </span>
    </span>
  );
}
